import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export function useActivityTracking() {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      await supabase
        .from('user_activity_log')
        .insert({
          user_id: user.id,
          activity_type: 'page_view',
          page_path: location.pathname,
          metadata: {
            timestamp: new Date().toISOString()
          }
        });
    };

    trackPageView();
  }, [location.pathname]);
}
